
import { Mapper } from "../../../../base/utils/mapper";
import { StaticDinamicEquilibriumNeurologyModel } from "../../../../domain/models/consult/static-dinamic-equilibrium-neurology.model";
import { StaticDinamicEquilibriumNeurologyEntity } from "../entities/static-dinamic-equilibrium-neurology.entity";

export class StaticDinamicEquilibriumNeurologyImplementationRepositoryMapper extends Mapper<StaticDinamicEquilibriumNeurologyEntity, StaticDinamicEquilibriumNeurologyModel>{
            mapFrom(param:  StaticDinamicEquilibriumNeurologyEntity):  StaticDinamicEquilibriumNeurologyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  StaticDinamicEquilibriumNeurologyModel):  StaticDinamicEquilibriumNeurologyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }